import * as R from 'ramda';
import { createSelector } from 'reselect';
//////////////////////////////////////////////////

const store = (state) => state.audit2;

const makeSelectAuditList = () => createSelector(
  store,
  ({ auditList }) => R.compose(
    R.sortBy(R.prop('index')),
    R.values,
  )(auditList),
);

const makeSelectPagination = () => createSelector(
  store,
  ({ pagination }) => pagination,
);

const makeSelectAuditLoading = () => createSelector(
  store,
  ({ loading }) => loading,
);

const makeSelectTotalCount = () => createSelector(
  store,
  ({ totalCount }) => totalCount,
);

const makeSelectObjGuidAndAuditType = () => createSelector(
  store,
  ({ type, objectGuid }) => ({ type, objectGuid }),
);

export {
  makeSelectAuditList,
  makeSelectPagination,
  makeSelectTotalCount,
  makeSelectAuditLoading,
  makeSelectObjGuidAndAuditType,
};
